// src/app/features/auth/useAuth.js
import { useEffect, useState } from "react";
import { getSession } from "../../state/authSession.js";

const AUTH_EVENT = "auth:changed";

export function useAuthSession() {
  // ✅ Initialize session and user synchronously
  const initialSession = getSession();
  
  const [session, setSession] = useState(initialSession);
  const [user, setUser] = useState(initialSession?.user || null);
  
  // ✅ FIX: Only show loading if there's no session initially
  const [loading, setLoading] = useState(!initialSession);

  useEffect(() => {
    const load = () => {
      const s = getSession();
      setSession(s);
      setUser(s?.user || null);
      setLoading(false);
    };

    // ✅ Only run load() if we didn't have an initial session
    if (!initialSession) {
      load();
    }

    const onStorage = (e) => {
      if (e.key === "session") load();
    };

    const onAuthChanged = () => load();

    window.addEventListener("storage", onStorage);
    window.addEventListener(AUTH_EVENT, onAuthChanged);

    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener(AUTH_EVENT, onAuthChanged);
    };
  }, []); // ✅ Empty deps - only run once

  return {
    session,
    user,
    loading,
    isAuthed: !!session?.accessToken, // ✅ Helper property
  };
}
